import { FILTER_TYPES, PAGE_SIZE_FILTER } from 'constants/filterType';
import { GRN_STATUS } from 'constants/grn';

export const GRN_FILTER_OPTIONS = [
  {
    field: 'grn_status',
    label: 'GRN Status',
    type: FILTER_TYPES.MULTI_SELECT,
    options: [...GRN_STATUS],
  },
  { ...PAGE_SIZE_FILTER },
];
